import { motion } from 'framer-motion';
import { FaInstagram, FaMailBulk, FaPhone } from 'react-icons/fa';
import { useEffect } from 'react';

function ContactMethod({ link, icon: Icon, text, label }) {
  return (
<a 
  href={link} 
  target="_blank" 
  rel="noopener noreferrer"
  className="group flex items-start gap-4 p-8 bg-[#0f0a07] border border-[#2a1f17] rounded-2xl hover:border-[#c6a15b] transition-all duration-300 hover:no-underline"
>
  <Icon className="text-[#c6a15b] text-2xl mt-1 transition-colors duration-300 group-hover:scale-110" />
  
  <div>
    <p className="text-sm text-[#c6a15b] uppercase tracking-wider mb-2">
      {label}
    </p>
    
    <p className="text-lg font-semibold text-[#f5f1ea] opacity-90 transition-all duration-300 group-hover:opacity-100">
      {text}
    </p>
  </div>
</a>

  );
}

export default function GetInTouch(props) {
  useEffect(() => {
    document.title = 'Maciej Głąb - Kontakt';
  }, []);

  return (
    <motion.div
  className="py-24 bg-[#14100d] min-h-[95vh]"
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  exit={{ opacity: 0, transition: { duration: 0.6 } }}
>
  <div className="max-w-5xl mx-auto px-6 lg:px-20">

    <h2 className="text-4xl font-serif text-center mb-16 text-[#c6a15b]">
      Skontaktuj się ze mną
    </h2>
        <p className="text-lg md:text-xl leading-relaxed text-[#f5f1ea] opacity-90 mb-16 max-w-3xl mx-auto">
      Jeśli chcesz zorganizować wyjątkową ceremonię saunową lub potrzebujesz porady dotyczącej rytuałów i aromaterapii, 
      chętnie odpowiem na Twoje pytania i dopasuję ofertę do Twoich potrzeb. 
      Poniżej znajdziesz wszystkie dostępne formy kontaktu.
    </p>
    {/* Contact Methods */}
    <div className="flex gap-2 flex-wrap">
      <ContactMethod
        icon={FaPhone}
        label="Telefon"
        link="tel:+48576998254"
        text="+48 576 998 254"
      />
      <ContactMethod
        icon={FaMailBulk}
        label="Email"
        link="mailto:maciekglabphoto@gmail.com"
        text="maciekglabphoto@gmail.com"
      />
      <ContactMethod
        icon={FaInstagram}
        label="Instagram"
        link="https://www.instagram.com/saunamaster.eu"
        text="@saunamaster.eu"
      />
    </div>

    {/* Footer note */}
    <div className="mt-16 text-center">
      <p className="text-[#f5f1ea] opacity-60 italic">
        Odpowiadam zazwyczaj w ciągu 24 godzin
      </p>
    </div>

  </div>
</motion.div>

  );
}